module.exports = "https://cdn-skillquest.mathletics.com/app/164/assets/images/0bbde3a654f3c63f32d12c4371b807a2.svg";